/**
 * External dependencies.
 */

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

function styling( props, selector = false ) {
	const { prefixFontSize, titleFontSize, suffixFontSize } = props.attributes;
	let css = '';
	selector = selector ? selector : `.gutenify-section-${ props.clientId }`;

	if ( prefixFontSize ) {
		css += `${ selector } .gutenify-section-title-prefix{
			${ prefixFontSize ? `font-size: ${ prefixFontSize }` : '' };
		}`;
	}
	if ( titleFontSize ) {
		css += `${ selector } .gutenify-section-title-main{
		${ titleFontSize ? `font-size: ${ titleFontSize }` : '' };
	}`;
	}
	if ( suffixFontSize ) {
		css += `${ selector } .gutenify-section-title-suffix{
		${ suffixFontSize ? `font-size: ${ suffixFontSize }` : '' };
	}`;
	}

	return applyFilters( `gutenify--${ hookPrefix }--inline-styles`, css, props );
}

export default styling;
